module.exports = __webpack_public_path__ + "static/media/gift_6.880c859f.png";